export default "__VITE_ASSET__103f4c5a__"